import { render, staticRenderFns } from "./GiftMessage.vue?vue&type=template&id=814830de&"
import script from "./GiftMessage.vue?vue&type=script&lang=js&"
export * from "./GiftMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports